import React, { useState } from "react";
import { loginUser } from "../api";
import "./Login.css";

export default function Login({ onLogin }) {
  const [userId, setUserId] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!userId.trim()) {
      setError("يرجى إدخال رقم الهوية");
      return;
    }
    setLoading(true);
    const { user, error: err } = await loginUser(userId);
    setLoading(false);
    if (user) {
      onLogin(user);
    } else {
      setError(err || "رقم الهوية غير موجود. يرجى التحقق والمحاولة مرة أخرى.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo-wrapper">
          <img
            src={`${process.env.PUBLIC_URL}/assets/logo_elharamain.png`}
            alt="الحرمين"
            className="login-logo"
          />
        </div>

        <h1 className="login-title">عيد مبارك</h1>
        <p className="login-desc">
          أدخل رقم هويتك للحصول على بطاقة تهنئة عيد مبارك الخاصة بك
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <label htmlFor="userId">رقم الهوية / Identity Number</label>
            <input
              id="userId"
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="e.g. 1046465678"
              autoFocus
              autoComplete="off"
              dir="ltr"
            />
          </div>
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "جارٍ التحقق…" : "دخول →"}
          </button>
        </form>
      </div>
    </div>
  );
}
